import { useState } from 'react';
import { useGenericExportTableMutation, ExportOptions } from '../services/api/export.api';
import i18n from '../i18n';

export const useTableExport = () => {
  const [genericExport, { isLoading: isExporting }] = useGenericExportTableMutation();
  const [error, setError] = useState<string | null>(null);

  const exportTable = async (options: ExportOptions) => {
    setError(null);
    try {
      const fullOptions = { ...options, language: options.language || i18n.language };
      const blob = await genericExport(fullOptions).unwrap();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${options.entity}_export_${new Date().getTime()}.${options.format === 'excel' ? 'xlsx' : 'pdf'}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (err: any) {
      console.error('Export failed', err);
      // If error response is a blob, we can try to extract text
      if (err?.data instanceof Blob) {
        try {
          const text = await err.data.text();
          setError(text);
          return;
        } catch (e) {
          // ignore parsing error
        }
      }
      setError(err?.message || err?.data?.message || err?.error || 'Export failed');
    }
  };

  return { exportTable, isExporting, error };
};
